import { clsx } from "clsx";

import { filledRadioButton, radioButton } from "../../../designSystemIcons";

type Props = {
  label: React.ReactNode;
  selected: boolean;
  select: () => void;
};

export const RadioButton = ({ label, selected, select }: Props) => {
  return (
    <button
      className="flex  gap-x-1 desktop:gap-x-3 desktop:group"
      onClick={select}
    >
      <div
        className={clsx(
          "w-5 h-5 my-auto shrink-0",
          selected ? "fill-white" : "fill-white/75",
        )}
      >
        {selected ? filledRadioButton : radioButton}
      </div>
      <div
        className={clsx(
          "my-auto text-xs desktop:text-sm rounded-lg p-2 text-white text-left ",
          selected
            ? "bg-white/20"
            : "group-hover:bg-white/10 bg-white/5 text-secondary",
        )}
      >
        {label}
      </div>
    </button>
  );
};

const SmallRadioButtonSvg = ({ selected }: { selected: boolean }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5.5" stroke="#788697" />
    <circle cx="6" cy="6" r="4" fill={selected ? "#788697" : "none"} />
  </svg>
);

export const SmallRadioButton = ({ label, selected, select }: Props) => {
  return (
    <button
      className="flex items-center gap-x-2 desktop:group"
      onClick={select}
    >
      <SmallRadioButtonSvg selected={selected} />
      <div className="my-auto text-xs text-white text-left">{label}</div>
    </button>
  );
};
